import { useMemo } from 'react';
import { ThirdPartyCall } from './ThirdPartyCall';
import { useConnectionStatus } from 'worker-connection-library/hooks/useConnectionStatus';
import { ConnectionStatusTypes } from 'shared-worker-versioning/lib/types/ConnectionStatuses';
import UnsupportedBrowserAlert from './UnsupportedBrowserAlert';

/**
 * ThirdPartyCallWrapper component that checks if connection is supported
 * and renders ThirdPartyCall if supported, or an alert if not supported
 */
import { jsx as _jsx } from "react/jsx-runtime";
const ThirdPartyCallWrapper = () => {
  const connectionStatus = useConnectionStatus();
  const hasConnectionUnsupported = useMemo(() => connectionStatus === ConnectionStatusTypes.UNSUPPORTED, [connectionStatus]);
  if (hasConnectionUnsupported) {
    return /*#__PURE__*/_jsx(UnsupportedBrowserAlert, {});
  }
  return /*#__PURE__*/_jsx(ThirdPartyCall, {});
};
export default ThirdPartyCallWrapper;